import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

export const registerUser = async (userData) => {
    const response = await api.post(`/auth/register`, userData);
    return response.data;
};

export const loginUser = async (credentials) => {
    const response = await api.post(`/auth/login`, credentials);
    return response.data;
};

// Make sure your auth service has proper logout functionality
export const logoutUser = () => {
  // Remove token from localStorage
  localStorage.removeItem('token');
  
  // Clear any other user data
  localStorage.removeItem('user');
  
  // Force page reload to clear all state
  window.location.href = '/';
};

export const getCurrentUser = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    
    // Decode JWT token to get user info
    const payload = JSON.parse(atob(token.split('.')[1]));
    
    // Check if token is expired
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem('token');
      return null;
    }
    
    return payload;
  } catch (error) {
    console.error('Error getting current user:', error);
    localStorage.removeItem('token');
    return null;
  }
};